import React, { createContext } from "react";

type ContextValue = {
  sandboxId: string;
  canChangePermissions: boolean;
};

export const shareContext = createContext<ContextValue>(
  {} as unknown as ContextValue,
);

type InjectedAPI = Record<string, () => void>;

type ShareSandboxProviderProps = {
  children: React.ReactNode;
  sandboxId: string;
  injectedAPI: InjectedAPI;
};

export const useShareContext = () => {
  const context = React.useContext(shareContext);
  if (context === undefined) {
    throw new Error(
      "useShareContext must be used within a ShareSandboxProvider",
    );
  }
  return context;
};

export const ShareSandboxProvider: React.FC<ShareSandboxProviderProps> = ({
  sandboxId,
  children,
}) => {
  return (
    <shareContext.Provider
      value={{
        sandboxId,
        canChangePermissions: true,
      }}
    >
      {children}
    </shareContext.Provider>
  );
};
